import { ISearchSuggestionProps } from '@1js/search-types';
import React from 'react';

import { KnownReferralPlatform } from '../../shared/instrumentation/instrumentation.service';
import { SearchInstrumentationService, SearchResultElementId, SearchResultType } from '../search-instrumentation.service';
import { SharedSearchService } from '../shared-search.service';
import { SearchSuggestionButtonComponent } from './search-suggestion-components/search-suggestion-button.component';

interface AppProps extends ISearchSuggestionProps {
    readonly isPwa: boolean;
    readonly isDarkMode: boolean;
    readonly referral: string;
    readonly searchInstrumentationService: SearchInstrumentationService;
    readonly sharedSearchService: SharedSearchService;
    readonly title: string;
    readonly url: string;
    readonly iconClass?: string;
}

export class AppSearchSuggestionComponent extends React.Component<AppProps> {

    public readonly handleClick = (props: any) => (e: React.MouseEvent | React.KeyboardEvent) => {
        e.preventDefault();
        this.props.sharedSearchService.setAppsAutosuggestClick(
                                            {
                                                ...props,
                                                id: props.id,
                                                customLoggingFunction: this.logAppsAutosuggestClick
                                            },
                                            e,
                                            undefined /* Third party apps */);
    }

    public render() {
        return(
            <SearchSuggestionButtonComponent
                title={this.props.title}
                icon={this.props.iconClass +  (this.props.isDarkMode && this.props.isPwa ? ' ms-ohp-Icon--see-more--darkMode' : ' ms-ohp-Icon--see-more')}
                isDarkMode={this.props.isDarkMode}
                isPwa={this.props.isPwa}
                handleClick={this.handleClick(this.props)}
                target='_blank'
            />
        );
    }

    private readonly logAppsAutosuggestClick = (success: boolean, knownReferralPlatform?: KnownReferralPlatform, pageNav?: boolean) => {
        if (success) {
            this.props.searchInstrumentationService.logSearchClickEvent(
                                                        SearchResultType.App,
                                                        SearchResultElementId.App,
                                                        pageNav,
                                                        SearchResultType.App,
                                                        undefined,
                                                        this.props.referral ? this.props.referral : this.props.title,
                                                        undefined,
                                                        undefined,
                                                        knownReferralPlatform);
        }
        // TODO: log failure case.
    }
}
